import script from "./ClearFiltersButtonContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClearFiltersButtonContainer.vue?vue&type=script&setup=true&lang=ts"

import "./ClearFiltersButtonContainer.vue?vue&type=style&index=0&id=24deae38&lang=css"

const __exports__ = script;

export default __exports__